export default {
  normal: 400,
  strong: 700,
}
